import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { parseDrupalSettingsVariants } from '../../utils/variants';
import ABTesting from '../../utils/ab-testing';

const useDynamicPdpDrupalSettings = () => {
  const { selectedUpgradeProduct } = useSelector((state) => state.pdp);
  const dynamicProduct = useMemo(() => {
    if (selectedUpgradeProduct !== undefined) {
      return window?.drupalSettings?.dynamic_pdps?.products?.find(
        (node) => node.id === selectedUpgradeProduct,
      );
    }
    return undefined;
  }, [selectedUpgradeProduct]);

  const productFromDrupalSettings = useMemo(
    () =>
      dynamicProduct?.data?.product
        ? {
            ...dynamicProduct.data.product,
            variants: parseDrupalSettingsVariants(
              dynamicProduct.data.product.variants,
            ),
          }
        : undefined,
    [dynamicProduct?.data?.product],
  );

  const mergedAovs = useMemo(
    () => ABTesting.formatMergedAovs(dynamicProduct?.data?.aovs),
    [dynamicProduct],
  );

  return {
    aovs: mergedAovs,
    product: productFromDrupalSettings,
    globalBadge: dynamicProduct?.data?.global_badge,
  };
};

export default useDynamicPdpDrupalSettings;
